"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tabsModule = _interopRequireDefault(require("./tabs.module.scss"));

var _excluded = ["fixed", "index", "inverse", "onChange", "children", "className", "headersClassName", "contentClassName"];

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {};

var parseChildren = function parseChildren(children) {
  var headers = [];
  var contents = [];

  _react["default"].Children.toArray(children).forEach(function (item) {
    headers.push(item);

    if (item.props.children) {
      contents.push(item.props.children);
    } else {
      contents.push(null);
    }
  });

  return {
    headers: headers,
    contents: contents
  };
};

var Tabs = function Tabs(_ref) {
  var fixed = _ref.fixed,
      index = _ref.index,
      inverse = _ref.inverse,
      onChange = _ref.onChange,
      children = _ref.children,
      className = _ref.className,
      headersClassName = _ref.headersClassName,
      contentClassName = _ref.contentClassName,
      others = _objectWithoutProperties(_ref, _excluded);

  var _parseChildren = parseChildren(children),
      headers = _parseChildren.headers,
      contents = _parseChildren.contents;

  var handleChange = function handleChange(_, i) {
    if (onChange) onChange(i);
  };

  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, others, {
    role: "tablist",
    className: (0, _classnames["default"])(_tabsModule["default"].tabs, className)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_tabsModule["default"].headers, headersClassName)
  }, headers && headers.map(function (item, idx) {
    return /*#__PURE__*/_react["default"].cloneElement(item, {
      children: null,
      key: idx,
      // eslint-disable-line
      index: idx,
      active: index === idx,
      onClick: handleChange.bind(_this)
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_tabsModule["default"].content, contentClassName)
  }, contents[index]));
};

Tabs.propTypes = {
  index: _propTypes["default"].number,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  headersClassName: _propTypes["default"].string,
  contentClassName: _propTypes["default"].string,
  fixed: _propTypes["default"].bool,
  inverse: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
Tabs.defaultProps = {
  index: 0,
  children: null,
  className: '',
  headersClassName: '',
  contentClassName: '',
  fixed: false,
  inverse: false,
  onChange: noop
};
var _default = Tabs;
exports["default"] = _default;